import { get, find, filter } from 'lodash';
import { createSelector } from 'reselect';

export const getApiIntegrations = state => get(state, 'apiConfiguration.apiIntegrations', []);
export const getApiIntegrationsLoading = state => get(state, 'apiConfiguration.isLoading', false);
export const getSelectedIntegrationMappingId = state => get(state, 'apiConfiguration.selectedIntegrationMappingId', '');
export const getSelectedIntegrationDetail = createSelector(
    [getSelectedIntegrationMappingId, getApiIntegrations],
    (selectedIntegrationMappingId, integrations) =>
        find(integrations, ['mappingId', selectedIntegrationMappingId]) || {}
);

export const getEnabledIntegrations = createSelector([getApiIntegrations], (integrations) =>
    filter(integrations, ({ enabled }) => enabled)
);